// A musical key as the app shows it, on every page: the server's label
// (cloudloop-flask app/music_key.py label(): sharps for C♯ and F♯, flats
// for E♭, A♭ and B♭, and G♯m for the minor key on 8), printed with real
// accidentals as the app's displayKey does (lib/models/sound.dart). The app
// reads a sound's key from that label (Sound.key), so the web spells a key
// from its pitch class through the same table.

const NAMES = ["C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab", "A", "Bb", "B"];
// Minor keys follow the usual key-signature spelling (G#m, not Abm).
const MINOR_NAMES = ["C", "C#", "D", "Eb", "E", "F", "F#", "G", "G#", "A", "Bb", "B"];

// "F#m" → "F♯m", "Bb" → "B♭" (the wire uses "#" and "b").
export function displayKey(key) {
  if (typeof key !== "string") return "";
  return key
    .trim()
    .replace(/^([A-Ga-g])#/, "$1♯")
    .replace(/^([A-Ga-g])b/, "$1♭");
}

// (6, true) → "F♯m", (10, false) → "B♭", (8, true) → "G♯m", (8) → "A♭";
// null when the pitch class is unknown.
export function keyName(pitchClass, isMinor) {
  if (pitchClass === null || pitchClass === undefined || pitchClass === "") return null;
  const pc = Number(pitchClass);
  if (!Number.isInteger(pc) || pc < 0 || pc > 11) return null;
  const name = (isMinor ? MINOR_NAMES : NAMES)[pc] + (isMinor ? "m" : "");
  return displayKey(name);
}
